import { render } from "./WNAbnormalCallList.vue?vue&type=template&id=53d117b8&scoped=true"
import script from "./WNAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./WNAbnormalCallList.vue?vue&type=script&lang=js"

import "./WNAbnormalCallList.vue?vue&type=style&index=0&id=53d117b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53d117b8"

export default script